import { render, staticRenderFns } from "./BasicLayoutMobile.vue?vue&type=template&id=40810d04&scoped=true&"
import script from "./BasicLayoutMobile.vue?vue&type=script&lang=js&"
export * from "./BasicLayoutMobile.vue?vue&type=script&lang=js&"
import style0 from "./BasicLayoutMobile.vue?vue&type=style&index=0&id=40810d04&lang=less&scoped=true&"
import style1 from "./BasicLayoutMobile.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40810d04",
  null
  
)

export default component.exports